export function Pager({ page, total, limit, onChange }: { page: number; total: number; limit: number; onChange: (page: number) => void }) {
  const pages = Math.max(1, Math.ceil(total / limit));
  if (pages <= 1) return null;
  return <nav className="pager" aria-label="Paginare">
    <button disabled={page <= 1} onClick={() => onChange(page - 1)}>‹</button>
    <span>Pagina {page} din {pages}</span>
    <button disabled={page >= pages} onClick={() => onChange(page + 1)}>›</button>
  </nav>;
}
